<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="674px"
    :before-close="handleClose"
    :close-on-click-modal="false"
    custom-class="detail-modal"
  >
    <template slot="title">
      <span
        style="
          display: inline-block;
          max-width: 460px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-left: 9px;
        "
      >
        {{ title }}
      </span>
    </template>
    <div>
      <div class="content">
        <div>
          <span class="content-header">
            <span class="line"></span
            ><span class="title">{{
              row.format.split("/")[0] == "video" ? "视频" : "图片"
            }}</span></span
          >
          <div class="video">
            <video
              :src="row.path"
              controlslist="nodownload"
              width="293"
              height="175"
              controls
              v-if="row.format.split('/')[0] == 'video'"
            ></video>
            <img v-else :src="row.path" class="imgpic" />
          </div>
        </div>
        <div :class="{ 'show-picture': row.format.split('/')[0] !== 'video' }">
          <span class="content-header">
            <span class="line"></span> <span class="title">封面</span></span
          >
          <div class="image" style="position: relative">
            <!-- <video
              v-if="row.format.split('/')[0] == 'video'"
              :src="row.path"
              width="293"
              height="175"
            ></video> -->
            <img :src="row.coverPath" class="imgpic" />
          </div>
        </div>
      </div>
      <div class="content-detail">
        <span class="form-item-detail">
          <span class="label">素材名称：</span>
          <span class="item" :title="row.name">{{ row.name }}</span>
        </span>
        <span class="form-item-detail">
          <span class="label">素材格式：</span>
          <span class="item">{{ row.format }}</span>
        </span>
        <span class="form-item-detail">
          <span class="label">素材ID：</span>
          <span class="item" :title="row.uuid">{{ row.uuid }}</span>
        </span>
        <span class="form-item-detail">
          <span class="label">创建时间：</span>
          <span class="item">{{ row.createDate }}</span>
        </span>
        <span class="form-item-detail">
          <span class="label">素材尺寸：</span>
          <span class="item">{{ row.resolution }}px</span>
        </span>
        <span class="form-item-detail">
          <span class="label">修改时间：</span>
          <span class="item">{{ row.modifyDate }}</span>
        </span>
        <span class="form-item-detail">
          <span class="label">素材类型：</span>
          <span class="item">{{ row.direction }}</span>
        </span>
        <span class="form-item-detail">
          <span class="label">设计师：</span>
          <span class="item">{{ row.designerName }}</span>
        </span>
        <span class="form-item-detail">
          <span class="label">大小：</span>
          <span class="item">{{ row.size }}M</span>
        </span>

        <span class="form-item-detail">
          <span class="label">时长：</span>
          <span class="item">{{ row.duration }}s</span>
        </span>
        <span class="form-item-detail">
          <span class="label">标签：</span>
          <span class="item">
            <el-tag :key="tag.id" v-for="tag in row.tags" class="tag-style">
              {{ tag.name }}
            </el-tag>
          </span>
        </span>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
// import { getDesignerFetch, setDesignerFetch } from "../../api/material";
export default {
  data() {
    return {
      visible: false,
      title: "",
      row: {
        uuid: "dcb7da07-c587-402c-8ca1-1a7419b79b57.mp4",
        name: "QQ视频 ",
        resolution: "720*1280",
        direction: "竖版",
        size: "1.87",
        duration: "4.986",
        format: "video/mp4",
        designer: "2",
        designerName: "饺子",
        path: "",
        tags: [{ id: 3, name: "hhhh" }],
        createDate: "2021-10-11 12:19:57",
        modifyDate: "2021-10-12 15:55:46",
      },
    };
  },
  mounted() {},
  methods: {
    handleClose() {
      this.visible = false;
    },

    showModal(row) {
      this.visible = true;
      this.title = row.name;
      this.row = row;
    },
  },
};
</script>

<style lang="less">
.detail-modal {
  background: rgba(255, 255, 255, 1);
  .content {
    display: flex;
    justify-content: space-around;

    .content-header {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      .line {
        height: 12px;
        width: 4px;
        background: rgba(24, 144, 255, 1);
        border-radius: 2px;
        margin-right: 5px;
      }
      .title {
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
      }
    }
    .image {
      width: 293px;
      height: 175px;
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.11);
      /* box-sizing: border-box; */
      background: #e8e8e8;
    }
    .video {
      width: 293px;
      height: 175px;
      border-radius: 4px;
      position: relative;
      margin: 0 auto;
      background: #e8e8e8;
      .imgpic {
        max-width: 100%;
        max-height: 175px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .content-detail {
    padding: 16px 0;
    display: flex;
    flex-wrap: wrap;
    background: rgba(244, 244, 244, 1);
    margin-top: 9px;
    border-radius: 2px;
    .form-item-detail:not(:last-child) {
      width: 50%;
      display: flex;
      align-content: center;
      height: 30px;
      line-height: 30px;
      .label {
        display: inline-block;
        width: 88px;
        text-align: right;
      }
      .item {
        display: inline-block;
        max-width: 195px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .form-item-detail:last-child {
      width: 50%;
      display: flex;
      align-content: center;

      .label {
        display: inline-block;
        width: 88px;
        text-align: right;
      }
      .item {
        display: inline-block;
        max-width: 500px;
        .tag-style {
          margin-bottom: 4px;
        }
      }
    }
    .form-item-detail:last-child {
      width: 100%;
    }
  }
  .show-picture {
    opacity: 0;
  }
}
</style>